var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded.global)?_c('div',{staticClass:"home",attrs:{"id":"home"}},[_c('HeaderHome',{attrs:{"id":"top"}}),_c('section',{attrs:{"id":"about"}},[_c('home-bio')],1),_c('home-current-project'),_c('home-services')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }